<template>
	<div>
		<!--图片-->
		<div class="img-file-wapper" v-if="isImg">
			<div class="fx file-n-wapper">
				<div class="file-n-cont">
					<ul class="fx fx-wrap">
						<li v-for ="(item,index) in listArr">
							<img :src="item" />
							<div class="pic-delete fx-align" @click="handleDelFile(index)"><span class="icon-del"></span></div>
						</li>
					</ul>
				</div>
				<div class="up-n-btn" v-if="fileNum != listArr.length">
					<input @change="handleFile" type="file">
					<a>
						<span class="icon-add file-add"></span>
						<span class="up-words">上传图片</span>
					</a>
				</div>
			</div>
		</div>
		
		<!----------------------------无耻的分割线------------------------------->
		<!--非图片文件-->
		<div class="words-file-wapper" v-else>
			<div class="file-n-wapper">
				<div class="file-n-cont">
					<ul>
						<li v-for ="(item,index) in listArr" class="fx">
							<p>{{item | urlFilter}}</p>
							<div class="file-delete m-l-5 fx-align" @click = "handleDelFile(index)"><span class="icon-del"></span></div>
						</li>
					</ul>
				</div>
				<div class="up-n-btn b-r-3" v-if="fileNum != listArr.length">
					<input @change="handleFile" type="file">
					<a class="z-btn z-btn-primary b-r-3">上传	</a>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	/*图片文件*/
	.file-n-wapper{
		.file-n-cont{
			li{
				margin-right: px-em(10px);
				width: px-em(160px);
				height: px-em(160px);
				border: 1px solid $color-border;
				position: relative;
				input[type="file"] {
					position: absolute;
					display: block;
					opacity: 0;
					z-index: 1;
					width: 100%;
					height: 100%;
					cursor: pointer;
				}
				img{
					width: 100%;
					height: 100%;
				}
				&:hover {
					.pic-delete {
						opacity: 1;
					}
				}
				.pic-delete{
					opacity: 0;
					position: absolute;
					top: 0;
					left: 0;
					bottom: 0;
					right: 0;
					width: 100%;
					height: 100%;
					cursor: pointer;
					background: rgba(0, 0, 0, 0.3);
					transition: all 0.2s ease;
					.icon {
						transition: all 0.2s ease;
						color: #EEEEEE;
						font-size: px-em(32px);
					}
				}
			}
		}	
		.up-n-btn{
			border: 1px solid $color-border;
			position: relative;
			margin-right: px-em(10px);
			width: px-em(160px);
			height: px-em(160px);
			overflow: hidden;
			cursor: pointer;
			input[type="file"] {
				position: absolute;
				display: block;
				opacity: 0;
				z-index: 1;
				width: 100%;
				height: 100%;
				cursor: pointer;
			}
			&:hover {
				a{
					background: rgba(0,0,0,0.08) !important;
				}
			}
			a{
				width: 100%;
				height: 100%;
				padding-top: px-em(20px);
				display: block;
				z-index: 0;
				text-align: center;
				transition: all 0.2s ease;
				color: $color-gray;
				span{
					display: block;
				}
				.file-add{
					font-size: px-em(44px);
					color: $color-gray;
					padding-top: px-em(16px);
				}
				.up-words{
					margin-top: px-em(6px);
				}
			}
		}
	}
	/*非图片文件*/
	.words-file-wapper{
		.file-one-cont,.file-n-cont li{
			width: auto;
			height: auto;
			border: none;
		}
		.file-n-wapper{
			.file-n-cont li{
				+ li{
					margin-top: px-em(20px);
				}
				.file-delete{
					cursor: pointer;
					.icon {
						transition: all 0.2s ease;
						color: $color-gray;
						&:hover{
							color: $color-main;
						}
					}
				}
			}
			.up-n-btn{
				width: px-em(200px);
				height: px-em(50px);
				border: none;
				cursor: pointer;
				a{
					color: #fff;
				}
				&:hover{
					opacity: 0.8;
					background: $color-main;
				}
			}
		}
	}
</style>
<script>
	/**
	 * z-up-file
	 * @module components/Search
	 * @desc 搜索组件
	 * @param {Boolean} [is-img] - 是否是图片，不传默认是图片
	 * @param {Number} [file-num] - 允许传多少张，不传则默认一张
	 * @param {Array} [list-arr] - 上传成功返回的图片路径地址数组
	 * @example
	 * <z-up-file :is-img = true :file-num = 2 :list-arr ="listArr"></z-up-file>
	 */
	export default {
		name: 'z-up-file',
		data() {
			return {
			}
		},
		props: {
		  	isImg: {
    			type:[Boolean,String],
				default: true
	   		},
			fileNum: {
	    		type:Number,
				default: 1
	   		},
	   		listArr: {
	    		type:[Object,Array],
				default: []
   			}
		},
		filters:{
			urlFilter(url){
				let fileUrlArr =  url.split('/uploads/')
				let fileName = fileUrlArr[fileUrlArr.length -1]
				return fileName
			}
		},
		methods: {
			handleFile() {
				let file = event.target.files[0]
				this.$log(file)
				this.$uploadsFile(file).then((result)=>{
					this.$log(result);
					this.listArr.push(result.url)
					this.$toast('上传成功');
				}, (err) => {
					this.$log(err);
				});
			},
			handleDelFile(index){//删除文件
				this.listArr.splice(index,1)
				this.$toast('删除成功');
			}
		}
	};
</script>


// WEBPACK FOOTER //
// UpFile.vue?71de2c10